import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { useRightSideBar } from '@p81-common/ui';

import Notification from '../parts/Notifications/Notifications';

import listUrl from 'data/breadCrumbsConfig.json';
import { upFirstLetter, getInitials } from 'utils/common';
import { getSocketInstance } from 'utils/jarvisApiClient';
import { useAuthState } from 'contexts/auth-context';
import { getRequest, postRequest } from 'utils/requests';
import { showNotif } from 'utils/notification';
import { useContent } from 'contexts/content-context';
import {
  pushActualStatus,
  setUnreadNotificationsCount
} from 'contexts/actions/contentAction';

export const useBreadCrumbs = () => {
  const location = useLocation();

  const crumbs = [];
  const makeBreadCrumbsLink = () => {
    let newUrl = '';
    const links = location.pathname.split('/');

    links.forEach((link, index) => {
      if (index !== 0) {
        const crumbCoincidence = listUrl.find(item => item.crumbName === link);
        if (crumbCoincidence) {
          newUrl = '';
          crumbCoincidence.realUrl
            ? (newUrl = newUrl + '/' + crumbCoincidence.realUrl)
            : (newUrl = newUrl + '/' + link);
          crumbs.push({
            text: upFirstLetter(crumbCoincidence.name),
            href: newUrl
          });
        } else {
          newUrl = newUrl + '/' + link;
          crumbs.push({ text: upFirstLetter(link), href: newUrl });
        }
      }
    });

    if (crumbs.length > 1) {
      if (crumbs[1].text === 'Аll Tenants' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/general';
      }
      if (crumbs[1].text === 'Features Adoption' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/environment';
      }
      if (crumbs[1].text === 'ARR Activity' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/general';
      }
      if (crumbs[1].text === 'Applications' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/general';
      }
      if (crumbs[1].text === 'Satisfaction Board' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/general';
      }
      if (crumbs[1].text === 'Cancellations' && crumbs.length > 2) {
        crumbs[2].href = crumbs[2].href + '/general';
      }
      if (
        crumbs.length > 4 &&
        crumbs[4].text === 'networks' &&
        crumbs.length > 6
      ) {
        crumbs[5].href = crumbs[5].href + '/network';
      }
    }
  };
  makeBreadCrumbsLink();

  const title = upFirstLetter(crumbs[crumbs.length - 1].text);
  document.title = `Jarvis - ${title || 'Perimeter81'}`;

  return crumbs;
};

export const useNotifications = () => {
  const [notifList, setNotifList] = useState([]);

  const { setComponentSecondaryDrawer, setOpenSecondary } = useRightSideBar();

  const unmount = useRef(false);

  const { user } = useAuthState().auth;

  const { contentDispatch, contentState } = useContent();

  useEffect(() => {
    // eslint-disable-next-line
    const socket = getSocketInstance();
    socket.on('connect', () => {
      socket.on('actualStatus', args => {
        if (args) {
          contentDispatch(pushActualStatus(args));
        }
      });
      socket.on('error', args => {
        // BE to FE
        if (args) {
          showNotif({
            message: args,
            kind: 'error',
            dismissAfter: 5000,
            type: 'alert'
          });
        }
      });
      socket.on('notification:list', (...args) => {
        // BE to FE
        if (args && args[0] && args[0].body) setNotifList(args[0].body);
      });

      socket.on('beaconStatus', args => {
        if (args) {
          contentDispatch({
            type: 'PUSH_BEACON_STATUS',
            payload: args
          });
          //contentDispatch(pushBeaconStatus(args));
        }
      });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, contentDispatch]);

  useEffect(() => {
    return () => {
      unmount.current = true;
    };
  }, []);

  const createData = data => {
    setNotifList(data);
  };

  const updateNotif = () => {
    if (user.id) {
      getRequest('/user/notifications/new').catch(err => {
        !unmount.current && console.log(err);
      });
      getRequest('/user/notifications/list')
        .then(res => {
          !unmount.current && createData(res.body);
        })
        .catch(err => {
          !unmount.current && console.log(err);
        });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      updateNotif();
    }, 10000000);
    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    updateNotif();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setCount();
    // eslint-disable-next-line
  }, [notifList]);

  const setCount = () => {
    contentDispatch(
      setUnreadNotificationsCount(
        notifList.filter(notif => !notif.isRead).length
      )
    );
  };

  const handleNotificationRing = () => {
    setComponentSecondaryDrawer(<Notification />);
    setOpenSecondary(true);
  };

  return {
    unreadCount: contentState.unreadNotificationsCount,
    handleNotificationRing
  };
};

export const useGlobalSearch = () => {
  const [options, setOptions] = useState({});
  const [searchValue, setSearchValue] = useState('');

  const history = useHistory();

  const handleSearchValue = (e, value) => {
    setSearchValue(value || '');
  };

  useEffect(() => {
    const REQ_BODY = {
      filter: searchValue
    };

    if (searchValue.length > 2 && searchValue.length < 50) {
      postRequest('/customers/search', REQ_BODY)
        .then(res => {
          setOptions(parserList(res.body));
        })
        .catch(err => {
          console.log(err);
        });
    }
    // eslint-disable-next-line
  }, [searchValue]);

  const parserList = list => {
    const arrList = {};

    if (list.accounts.length > 0) {
      arrList.Accounts = list.accounts.map(item => ({
        label: item.companyName,
        subtitle: item.customerId,
        companyIconProps: { domain: item.website },
        componentType: 'Tenant',
        customerId: item.customerId
      }));
    }

    if (list.users.length > 0) {
      arrList.Users = list.users.map(item => ({
        label: `${item.firstName} ${item.lastName}`,
        email: item.email,
        componentType: 'User',
        avatarImgSrc: item?.src,
        customerId: item.customerId
      }));
    }

    return arrList;
  };

  const handleLinkGlobalSearch = id => {
    history.push(`/customers/all-tenants/${id}/general`);
  };

  return {
    handleLinkGlobalSearch,
    handleSearchValue,
    groupedOptions: searchValue && searchValue.length > 2 ? options : {}
  };
};

export const userControlsProps = () => {
  const { auth } = useAuthState();
  const { user } = auth;

  return {
    name: `${user.firstName} ${user.lastName}`,
    userRole: user.role,
    avatarProps: {
      initials: getInitials(user.firstName, user.lastName),
      src: user.icon,
      color: user.initialsColor
    },
    showIconSearch: false,
    showIconSettings: false,
    showIconNotification: false
  };
};
